export default __webpack_public_path__ + "static/media/peopleIcon.712627d6.svg";